<section class="tickets-page">
  <header class="tickets-toolbar">
    <div>
      <h1>Билеты</h1>
      <span>Управление билетами по событиям.</span>
    </div>
  </header>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="tickets-panel">
    <div class="table-wrap" *ngIf="pagedEvents.length > 0; else emptyState">
      <table class="tickets-table">
        <thead>
          <tr>
            <th><button type="button" (click)="setSort('date')" [attr.aria-sort]="sortState('date')">Дата</button></th>
            <th><button type="button" (click)="setSort('match')" [attr.aria-sort]="sortState('match')">Матч</button></th>
            <th><button type="button" (click)="setSort('total')" [attr.aria-sort]="sortState('total')">Всего</button></th>
            <th><button type="button" (click)="setSort('available')" [attr.aria-sort]="sortState('available')">В наличии</button></th>
            <th><button type="button" (click)="setSort('reserved')" [attr.aria-sort]="sortState('reserved')">Резерв</button></th>
            <th><button type="button" (click)="setSort('sold')" [attr.aria-sort]="sortState('sold')">Выкуплено</button></th>
            <th><button type="button" (click)="setSort('purchase')" [attr.aria-sort]="sortState('purchase')">Закупка</button></th>
            <th><button type="button" (click)="setSort('profit')" [attr.aria-sort]="sortState('profit')">Плановая прибыль</button></th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="ticket-row"
            *ngFor="let event of pagedEvents; trackBy: trackById"
            [routerLink]="['/dashboard/tickets', event.slug || event.id]"
          >
            <td>{{ formatDate(event.startsAt) }}</td>
            <td>
              <div class="match-cell">
                <div class="match-teams">
                  <span class="team-side">
                    <span class="team-logo" [style.background-image]="getLogoBackground(event.homeTeam)">{{ event.homeTeam.logoUrl ? '' : event.homeTeam.name.charAt(0) }}</span>
                    <strong>{{ event.homeTeam.name }}</strong>
                  </span>
                  <span class="match-divider">-</span>
                  <span class="team-side">
                    <span class="team-logo" [style.background-image]="getLogoBackground(event.awayTeam)">{{ event.awayTeam.logoUrl ? '' : event.awayTeam.name.charAt(0) }}</span>
                    <strong>{{ event.awayTeam.name }}</strong>
                  </span>
                </div>
                <small>{{ event.seasonName }}</small>
              </div>
            </td>
            <td><strong>{{ event.summary.ticketsTotal }}</strong></td>
            <td><span class="status-number available">{{ countTicketsByStatus(event, 'available') }}</span></td>
            <td><span class="status-number reserved">{{ countTicketsByStatus(event, 'reserved') }}</span></td>
            <td><span class="status-number sold">{{ countTicketsByStatus(event, 'sold') }}</span></td>
            <td>{{ formatMoney(event.summary.purchaseTotal) }}</td>
            <td>{{ formatMoney(event.summary.plannedProfitAfterExpenses) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyState>
      <div class="empty-state">
        <h3>{{ loading ? 'Обновляем билеты...' : 'Событий в работе пока нет' }}</h3>
        <p *ngIf="!loading">Билеты появляются здесь только для событий со статусом «В работе».</p>
        <a class="action-button primary" routerLink="/dashboard/events" *ngIf="!loading">К событиям</a>
      </div>
    </ng-template>

    <footer class="pagination-bar">
      <span>Страница {{ page }} из {{ totalPages }}</span>
      <label class="page-size-control">
        <span>Показывать</span>
        <select class="form-select" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let pageSizeOption of pageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
        </select>
      </label>
      <div class="pagination-actions">
        <button class="action-button ghost" type="button" [disabled]="page === 1" (click)="goToPage(page - 1)">Назад</button>
        <button class="action-button ghost" type="button" [disabled]="page === totalPages" (click)="goToPage(page + 1)">Вперед</button>
      </div>
    </footer>
  </section>
</section>
